import axiosInstance from '../utils/AxiosConfig';

import { DEFAULT_CURRENCY, getActiveCurrency } from '../utils/currency';

export const getCostAlertsData = async () => {
  const params = {};
  if (getActiveCurrency() !== DEFAULT_CURRENCY) params.currency = getActiveCurrency();
  const response = await axiosInstance.get('/reports/cost-alerts', { params });
  return response.data;
};
